import { create } from "zustand";
import * as pc from "playcanvas";

type AutoPlayData = {
  time: number;
  delay: number;
};

interface PlaygroundState {
  positionJoystickData: number[];
  setPositionJoystickData: (value: number[]) => void;
  rotationJoystickData: number[];
  setRotationJoystickData: (value: number[]) => void;

  isModelLoaded: boolean;
  setIsModelLoaded: (value: boolean) => void;

  avatarPathProgress: number;
  setAvatarPathProgress: (progress: number) => void;

  startAutoPlayData: AutoPlayData;
  startAutoPlayDelay: (delay: number) => void;

  stopAutoPlayData: number;
  stopAutoPlay: () => void;

  isShowJoystick: boolean;
  setIsShowJoystick: (value: boolean) => void;

}

export const usePlaygroundStore = create<PlaygroundState>()((set, get) => ({
  positionJoystickData: [0, 0],
  setPositionJoystickData: (value: number[]) => {
    set({ positionJoystickData: value });
  },
  rotationJoystickData: [0, 0],
  setRotationJoystickData: (value: number[]) => {
    set({ rotationJoystickData: value });
  },

  isModelLoaded: false,
  setIsModelLoaded: (value: boolean) => {
    set({ isModelLoaded: value });
  },

  avatarPathProgress: 0,
  setAvatarPathProgress: (progress: number) => {
    set({ avatarPathProgress: progress });
  },

  startAutoPlayData: { time: -1, delay: -1 },
  startAutoPlayDelay: (delay: number) => {
    console.log("!!!!");
    set({ startAutoPlayData: { time: Date.now(), delay: delay } });
  },

  stopAutoPlayData: -1,
  stopAutoPlay: () => {
    set({ stopAutoPlayData: Date.now() });
  },

  isShowJoystick: false,
  setIsShowJoystick: (value: boolean) => {
    set({isShowJoystick: value});
  }
}));
